import { useSelector } from 'react-redux'
import { useAction } from '../utils/react-redux'
import { displayModal, hideModal } from '../../store/ui/ui.actions'
import { isModalDisplayed } from '../../store/ui/ui.selectors'
import useErrorBoundaryCallback from '../utils/useErrorBoundaryCallback'

export const useModal = modalId => {
  const execShow = useAction(displayModal)
  const execHide = useAction(hideModal)
  const isDisplayed = useSelector(isModalDisplayed(modalId))
  const display = useErrorBoundaryCallback(() => execShow(modalId), [execShow, modalId])
  const hide = useErrorBoundaryCallback(() => execHide(modalId), [execHide, modalId])
  return {
    isModalDisplayed: isDisplayed,
    displayModal: display,
    hideModal: hide
  }
}

export default useModal
